<template>
    <div>
        <b-card v-show="editMode===0">
            <b-row>
                <b-col sm="12" class="text-right">
                    <b-btn-group size="sm">
                        <b-button variant="white" class="button-icon-only mr-1" title="Обновить"
                                  @click="buttonRefreshClicked"
                        >
                            <i class="fa fa-sync"/>
                        </b-button>
                    </b-btn-group>
                </b-col>
            </b-row>
            <MyToolbar>
                <MyToolbarItem>
                    <b-input v-model="searchQuickFilter" @keyup.prevent.enter="buttonSearchClicked" maxlength="200"
                             size="sm" placeholder="Поиск..." ref="inputQuickFilter" @keyup.esc="searchQuickFilter=''"
                    />
                </MyToolbarItem>
                <MyToolbarItem>
                    <b-button size="sm" variant="secondary" @click="buttonSearchClicked">Поиск</b-button>
                    <b-button size="sm" :variant="sortMode===0 ? 'secondary' : 'primary'" title="Расширенный поиск"
                              class="button-icon-only-normal ml-2"
                              @click="buttonAdvSearchShowClicked"
                    >
                        <i class="fas fa-cog"/>
                    </b-button>
                </MyToolbarItem>
            </MyToolbar>

            <b-alert :show="err" :variant="errVariant" class="mb-4">{{errText}}</b-alert>

            <b-table outlined hover head-variant="light" :fields="rpModelsFields" :items="rpModels"
                     responsive="responsive" :no-local-sorting="true" sort-by="ISCode"
                     @row-clicked="tableRowClicked"
                     @sort-changed="sortChanged"
            >
            </b-table>
            <b-row>
                <b-col sm="6">
                    <b-pagination first-number last-number
                                  v-model="recordCurrentPageNumber" @input="loadRpModels"
                                  :total-rows="recordTotalNumber" :per-page="recordCountPerPage"
                    />
                </b-col>
                <b-col sm="6">
                    <div class="custom-items-per-page-div">
                        <label>Показать записей:</label>
                        <b-form-select id="input-records-per-page" size="sm" style="margin-left: 10px;width:65px"
                                       :options="recordCountPerPageArray" v-model="recordCountPerPage"
                                       @change="loadRpModels"
                        />
                    </div>
                </b-col>
            </b-row>
        </b-card>
        <b-card v-show="editMode===1" title="Просмотр записи">
            <b-alert :show="err" :variant="errVariant" class="mb-3">{{errText}}</b-alert>
            <b-form @reset.prevent="cancelRecord">
                <b-row>
                    <b-col md="12">
                        <b-form-group v-if="userActionAccessCompany" label="РЭК" label-for="input-edit-company">
                            <b-input id="input-edit-company" v-model="editCompany" @keyup.esc="cancelRecord"
                                     readonly="readonly" ref="inputEditCompany"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4">
                        <b-form-group label="Код 1С" label-for="input-edit-is-code">
                            <b-input id="input-edit-is-code" v-model="editIsCode" @keyup.esc="cancelRecord"
                                     readonly="readonly" ref="inputEditIsCode"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4">
                        <b-form-group label="Модель ПУ" label-for="input-edit-rp-model-name">
                            <b-input id="input-edit-rp-model-name" v-model="editRpModelName" @keyup.esc="cancelRecord"
                                     readonly="readonly"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4">
                        <b-form-group label="Ампер" label-for="input-edit-ampere">
                            <b-input id="input-edit-ampere" v-model="editAmpere" @keyup.esc="cancelRecord"
                                     readonly="readonly"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4">
                        <b-form-group label="Разрядность" label-for="input-edit-digits">
                            <b-input id="input-edit-digits" v-model="editDigits" @keyup.esc="cancelRecord"
                                     readonly="readonly"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4">
                        <b-form-group label="Фазность" label-for="input-edit-phase">
                            <b-input id="input-edit-phase" v-model="editPhase" @keyup.esc="cancelRecord"
                                     readonly="readonly"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4">
                        <b-form-group label="Период замены" label-for="input-edit-replacement-period">
                            <b-input id="input-edit-replacement-period" v-model="editReplacementPeriod"
                                     @keyup.esc="cancelRecord" readonly="readonly"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4">
                        <b-form-group label="Тип ПУ" label-for="input-edit-rp-type">
                            <b-input id="input-edit-rp-type" v-model="editRpType"
                                     @keyup.esc="cancelRecord" readonly="readonly"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <hr/>
                <b-button type="reset" variant="secondary">Закрыть</b-button>
            </b-form>
        </b-card>

        <b-modal ref="modal-search" hide-footer centered title="Расширенный поиск" @hidden="modalHidden">
            <b-alert :show="errModal" :variant="errVariantModal" class="mb-4">{{errTextModal}}</b-alert>
            <b-row>
                <b-col sm="12" v-if="userActionAccessCompany">
                    <b-form-group label="РЭК" label-for="input-AdvSearch-company">
                        <b-select id="input-AdvSearch-company" :options="searchCompanies"
                                  v-model="searchCompanyUid" autofocus
                        />
                    </b-form-group>
                </b-col>
                <b-col sm="12">
                    <b-form-group label="Статус записи" label-for="input-AdvSearch-record-status">
                        <b-select id="input-AdvSearch-record-status" :options="searchRecordStatuses"
                                  v-model="searchRecordStatus"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <div>
                <b-button variant="outline-danger" @click="buttonAdvSearchCancelClicked">Сбросить</b-button>
                <b-button variant="secondary" class="ml-2 float-right" @click="buttonAdvSearchCloseClicked">Закрыть
                </b-button>
                <b-button variant="primary" class="float-right" @click="buttonAdvSearchOkClicked">Поиск</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
    import MyToolbar from "@/view/components/MyToolbar";
    import MyToolbarItem from "@/view/components/MyToolbarItem";
    import axios from "axios";

    export default {
        name: "RPModels",
        components: {MyToolbar, MyToolbarItem},
        data() {
            return {
                userData: this.$store.getters.getUserData,
                recordCountPerPageArray: this.$store.getters.getRecordCountPerPageArray || [],
                recordCountPerPage: this.$store.getters.getRecordCountPerPage || 20,
                recordCurrentPageNumber: 1,
                recordTotalNumber: 0,

                userActionAccessArray: [],
                userActionAccessCompany: 0,

                loadProcessing: 0,

                editMode: 0,
                recordUid: "",

                err: false,
                errText: "",
                errVariant: "danger",

                errModal: false,
                errTextModal: "",
                errVariantModal: "danger",

                searchQuickFilter: "",
                searchRecordStatus: -1,
                searchCompanyUid: 0,

                sortMode: 0,    //0-simple, 1-advanced
                sortBy: "ISCode",
                sortDesc: false,

                searchRecordStatuses: [
                    {'value': -1, 'text': "<все>"},
                    {'value': 0, 'text': "готов"},
                    {'value': 1, 'text': "только чтение"},
                    {'value': 2, 'text': "заблокирован"},
                    {'value': 3, 'text': "на удаление"},
                    {'value': 4, 'text': "в архиве"},
                ],
                searchCompanies: [],

                rpModels: [],
                rpModelsFields: [
                    {key: "RowNumber", label: "№", tdClass: "pointer"},
                    {key: "CompanyAlias", label: "РЭК", tdClass: "pointer"},
                    {key: "ISCode", label: "Код 1С", sortable: true, tdClass: "pointer"},
                    {key: "RPModelName", label: "Модель ПУ", sortable: true, tdClass: "pointer"},
                    {key: "Ampere", label: "Ампер", sortable: true, tdClass: "pointer"},
                    {key: "Digits", label: "Разрядность", sortable: true, tdClass: "pointer"},
                    {key: "Phase", label: "Фазность", sortable: true, tdClass: "pointer"},
                    {key: "ReplacementPeriod", label: "Период замены", sortable: true, tdClass: "pointer"},
                    {key: "RPType", label: "Тип ПУ", sortable: true, tdClass: "pointer"},
                ],

                editCompany: "",
                editIsCode: "",
                editRpModelName: "",
                editAmpere: "",
                editDigits: "",
                editPhase: "",
                editReplacementPeriod: "",
                editRpType: ""

            }
        },
        created() {
            this.userActionAccessArray = this.getUserActionAccessArray("RefsRPModels", this.userData.UserAccess)
            this.userActionAccessCompany = this.getUserDataAccess("RefsCompanies", this.userData.UserAccess)
        },
        mounted() {
            this.$store.dispatch(SET_BREADCRUMB, [
                {title: "Справочники", route: "rp-models"},
                {title: "Модели ПУ"}
            ]);

            this.loadRpModels()
            if (this.userData.UserGroupUid === 1) this.loadCompanies()

            //If not Admin - delete Company from the list
            if (this.userData.UserGroupUid !== 1) {
                let ind = this.rpModelsFields.findIndex(item => item.key.toLowerCase() === "companyalias");
                if (ind >= 0)
                    this.rpModelsFields.splice(ind, 1)
            }

            //If no access to archive
            if (!this.userActionAccessArray['archive']) {
                let ind = this.searchRecordStatuses.findIndex(item => item.value === 4);
                if (ind >= 0)
                    this.searchRecordStatuses.splice(ind, 1)
            }

            this.$nextTick(() => {
                this.$refs.inputQuickFilter.$el.focus()
            })
        },
        methods: {
            errTextHide() {
                this.err = false
                this.errText = ""
            },
            errTextShow(msg, variant = "danger", withScroll = true) {
                if (withScroll)
                    window.scrollTo(0, 0)
                this.errText = msg
                this.errVariant = variant
                this.err = true
            },
            errTextHideModal() {
                this.errModal = false
                this.errTextModal = ""
            },
            errTextShowModal(msg, variant = "danger", withScroll = true) {
                if (withScroll)
                    window.scrollTo(0, 0)
                this.errTextModal = msg
                this.errVariantModal = variant
                this.errModal = true
            },
            loadCompanies() {
                this.searchCompanies = [{'value': 0, 'text': "<все>"}]

                axios.post("/ws/ws.svc/GetRefsCompaniesArray", {
                        'Session_UID': this.userData.Session_UID,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                            if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)
                                || this.isUndefined(resp.data.data)) {
                                this.errTextShow("Неверный формат ответа.")
                            } else {
                                if (resp.data.success) {
                                    if (resp.data.data.toString().length > 0) {
                                        let result = JSON.parse(resp.data.data)
                                        result.data.forEach(item => {
                                            this.searchCompanies.push({'value': item.UID, 'text': item.Alias})
                                        })
                                    }
                                } else {
                                    this.errTextShow(resp.data.response.toString())
                                }
                            }
                        }
                    )
                    .catch(err => {
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")")
                    })
            },
            loadRpModels() {
                this.errTextHide()

                this.loadProcessing++
                axios.post("/ws/ws.svc/GetRefsRPModels", {
                        'Session_UID': this.userData.Session_UID,
                        'Page': this.recordCurrentPageNumber,
                        'RecordsPerPage': this.recordCountPerPage,
                        'SortField': this.sortBy,
                        'SortMode': (this.sortDesc ? 1 : 0),
                        'F_Company_UID': this.searchCompanyUid,
                        'F_RPModelName': this.searchQuickFilter,
                        'F_RS': this.searchRecordStatus,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                        if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response) ||
                            this.isUndefined(resp.data.data) || this.isUndefined(resp.data.meta)) {
                            this.errTextShow("Неверный формат ответа.", "danger", true)
                        } else {
                            if (resp.data.success) {
                                if (resp.data.data.toString().length > 0) {
                                    this.rpModels = JSON.parse(resp.data.data)
                                    if (!this.isUndefined(resp.data.meta.TotalRecordsAmount)) {
                                        this.recordTotalNumber = resp.data.meta.TotalRecordsAmount
                                    } else {
                                        this.errTextShow("Ошибка при получении общего кол-ва записей.", "danger", true)
                                    }
                                } else {
                                    this.recordTotalNumber = 0
                                    this.rpModels = []

                                }
                            } else {
                                this.errTextShow(resp.data.response.toString(), "danger", true)
                            }
                        }
                        this.loadProcessing--
                    })
                    .catch(err => {
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")", "danger", true)
                        this.loadProcessing--
                    })
            },
            tableRowClicked(item) {
                this.errTextHide()
                this.recordUid = item.UID
                this.editCompany = ""
                this.editIsCode = ""
                this.editRpModelName = ""
                this.editAmpere = ""
                this.editDigits = ""
                this.editPhase = ""
                this.editReplacementPeriod = ""
                this.editRpType = ""

                this.loadProcessing++
                axios.post("/ws/ws.svc/GetRefsRPModel", {
                        'Session_UID': this.userData.Session_UID,
                        'F_UID': this.recordUid,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                        if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)) {
                            this.errTextShow("Неверный формат ответа.", "danger", true)
                        } else {
                            if (resp.data.success) {
                                if (resp.data.data.toString().length > 0) {
                                    let result = (JSON.parse(resp.data.data))

                                    this.editCompany = !this.isUndefined(result.CompanyAlias) ? result.CompanyAlias : ""
                                    this.editIsCode = result.ISCode.toString()
                                    this.editRpModelName = result.RPModelName.toString()
                                    this.editAmpere = result.Ampere.toString()
                                    this.editDigits = result.Digits.toString()
                                    this.editPhase = result.Phase.toString()
                                    this.editReplacementPeriod = result.ReplacementPeriod.toString()
                                    this.editRpType = result.RPType.toString()
                                } else {
                                    this.errTextShow("Запись не найдена. Пожалуйста, обновите страницу.", "danger", true)
                                }
                            } else {
                                this.errTextShow(resp.data.response.toString(), "danger", true)
                            }
                        }

                        this.editMode = 1
                        this.loadProcessing--
                        if (this.userActionAccessCompany) {
                            this.$nextTick(() => {
                                this.$refs.inputEditCompany.$el.focus()
                            })
                        } else {
                            this.$nextTick(() => {
                                this.$refs.inputEditIsCode.$el.focus()
                            })
                        }
                    })
                    .catch(err => {
                        this.editMode = 1
                        this.loadProcessing--
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")", "danger", true)
                    })
            },
            cancelRecord() {
                this.errTextHide()
                this.editMode = 0
            },
            sortChanged(e) {
                this.sortBy = e.sortBy
                this.sortDesc = e.sortDesc
                this.loadRpModels()
            },
            buttonSearchClicked() {
                this.recordCurrentPageNumber = 1
                this.loadRpModels()
            },
            buttonAdvSearchShowClicked() {
                this.$refs['modal-search'].show()
            },
            buttonAdvSearchOkClicked() {
                if (this.searchCompanyUid !== 0 || this.searchRecordStatus !== -1) {
                    this.sortMode = 1
                    this.searchQuickFilter = ""
                } else {
                    this.sortMode = 0
                }

                this.recordCurrentPageNumber = 1
                this.loadRpModels()
                this.$refs['modal-search'].hide()
            },
            buttonAdvSearchCancelClicked() {
                this.sortMode = 0
                this.searchCompanyUid = 0
                this.searchRecordStatus = -1
                this.recordCurrentPageNumber = 1
                this.$refs['modal-search'].hide()
                this.loadRpModels()
            },
            buttonAdvSearchCloseClicked() {
                this.$refs['modal-search'].hide()
            },
            modalHidden() {
                this.$nextTick(() => {
                    this.$refs.inputQuickFilter.$el.focus()
                })
            },
            buttonRefreshClicked() {
                this.loadRpModels()
            },
        },
        watch: {
            loadProcessing: function () {
                this.$store.commit('set', ["showSpinner", this.loadProcessing > 0])
            },
        }
    }
</script>

<style scoped>

</style>